module.exports = __webpack_public_path__ + "img/fairJoin.c81bc5b4.jpg";